import { useEffect } from 'react';
import {
  Stack,
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useAuthContext } from 'src/auth/hooks';
import { useSnackbar } from 'notistack';
import usePlaidLinkToken from './usePlaidLink';
// import FinancialInstitutionModal from './FinancialInstitutionModal';

export default function AddAccount() {
  const { user } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  // const [show, setShow] = useState(false);
  // const [open, close] = [() => setShow(true), () => setShow(false)];

  const can_add_accounts = user.email !== 'married@growbread.com';

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!can_add_accounts) return <></>;
  const { generateToken, loading, error, success } = usePlaidLinkToken();

  useEffect(() => {
    if (!loading) {
      if (success) enqueueSnackbar('Account added successfully', { variant: 'success' });
      if (error) enqueueSnackbar('Error adding account', { variant: 'error' });
    }
  }, [success, error, loading]);

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 1000 }}>
        <CircularProgress />
      </Backdrop>
      <Card>
        <CardActionArea onClick={generateToken}>
          <CardContent>
            <Stack margin={5} spacing={2} alignItems="center" justifyContent="center" flex={1}>
              <AddIcon />
              <strong>Add an Account</strong>
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
      {/* <FinancialInstitutionModal open={show} onClose={close} /> */}
    </>
  );
}
